<div class="content">
  <div>
    <mat-spinner></mat-spinner>
  </div>
  <div>
    <span>Sidan laddas</span>
  </div>
</div>
